import { MouseEvent } from 'react';
import { IconButton, IconMoreVert } from 'cdk-radial';
import * as Styles from '../../core/styles-card';
import toTestId from '../../utils/toTestId';
import { useTranslation } from 'react-i18next';
import { withTooltip,THEMES } from 'cdk-radial';
import { isBlockedByOS, shouldShowWarning } from '../../../util/osUtils';
import { IAdoptEaseCampaign } from '../../adopt-ease/AdoptEaseCampaignInterface';
import { getCampaignText } from '../../adopt-ease/adoptEaseCampaignUtils';
//import { useShowDialog } from '../../contexts/AppStateContext';

interface Props {
  id:string;
  isIconRequired? :boolean;
  isEnabled: boolean;
  warningMessage?: string;
  requiredOS?: string[];
  description?: string;
  name: string;
  iconText?: string;
  onOpenClick: (e:MouseEvent) => void;
  iconColor: string;
  menuRef:any
  isRestricted?: boolean;
  restrictedTooltipMsg?: string;
  onTryNewAdoptEaseClick?: Function;
  showTryNewAdoptEaseButton?: Function;
  showTryNewAdoptEaseCampaign?: (id: string) => IAdoptEaseCampaign | undefined;
  onTryNewAdoptEaseCampaignClick?: (campaign: IAdoptEaseCampaign) => void;
  showNewIndicator?: boolean;
  locale:string
  isMobileApp?: boolean;
}

export interface CardMenu {
  key: string;
  label: string;
  icon?: any;
}

const ComponentToRender = (props:any) => {
  const { t } = useTranslation();
  return (
    <Styles.WarningMessage {...props}>
      <Styles.WarningIcon height={18} width={18} dataTestId="restricted-warning"/>
      {t('baseCard.restrictedWarning')}
      </Styles.WarningMessage>
  );
};

export const RestrictedTooltip = ({message}:any) =>{
  const RestrictedWarningIcon =  withTooltip(ComponentToRender, 
    {
      id:`restricted-tooltip-icon`,
      text:message, 
      theme:THEMES.LIGHT,
      styles:{ zIndex:1002, display: window.innerWidth < 501 && 'none' }}
  );
  return <RestrictedWarningIcon></RestrictedWarningIcon>;
}


export const NewCardIndicator = ({locale}:any) =>{
    const { t } = useTranslation();
  return (
    <Styles.StatusIndicatorIcon style={{ right:(locale === 'en_FR') ? '37px' : '7px'  }}>
           <svg width="13" height="16" xmlns="http://www.w3.org/2000/svg">
          &nbsp; <rect width="10" height="10" x="0" y="3" rx="2" ry="2" fill="#09AD00"></rect>
            Sorry, your browser does not support inline SVG.  
          </svg><Styles.StatusIndicatorText>{ t('baseCard.new') }</Styles.StatusIndicatorText>
        </Styles.StatusIndicatorIcon>
  )
}

export const TryNowButtonAdoptEaseIndicator = ({onTryNewAdoptEaseClick, text, dataTestId = 'try-now', showIcon = true}:any) =>{
    const { t } = useTranslation();
  return (
    <Styles.TryNowButton
      tabIndex={0}
      onClick={onTryNewAdoptEaseClick}
      onKeyDown={(e: any) => {
        if (e.key === 'Enter') {
          onTryNewAdoptEaseClick(e)
        }
      }}
      data-testid={dataTestId}>
      <div style={{ height: '16px', display: 'flex', alignItems: 'center', gap: '2px', minWidth: 0 }}>
        {showIcon && <svg fill="#155EBF" width="16px" height="16px" viewBox="0 0 512 512">
          <g id="Graduation">
            <polygon points="445.055 384.794 445.055 221.864 418.805 234.989 418.805 384.777 401.301 429.785 462.551 429.785 445.055 384.794" />
            <path d="M229.0648,306.3708l-107.7643-53.88v53.7754c0,36.2433,58.7634,65.625,131.25,65.625,72.4887,0,131.25-29.3817,131.25-65.625V252.49L276.0277,306.3741C257.5813,313.681,247.5133,313.6789,229.0648,306.3708Z" />
            <path d="M264.2912,282.8969l186.5207-93.26c6.4579-3.2289,6.4579-8.5107,0-11.74l-186.5207-93.26c-6.4556-3.2289-17.0214-3.2289-23.4793,0l-186.5207,93.26c-6.4556,3.2289-6.4556,8.5107,0,11.74l186.5207,93.26C247.27,286.1258,257.8356,286.1258,264.2912,282.8969Z" />
          </g>
        </svg>}
        <Styles.TryNowText>
          {text || t('adoptease.tryNow')}
        </Styles.TryNowText>
      </div>
    </Styles.TryNowButton>
  )
}


export default function Card({
  id,
  isIconRequired,
  isEnabled,
  warningMessage,
  requiredOS,
  description,
  name,
  iconText,
  iconColor,
  onOpenClick,
  menuRef,
  isRestricted,
  restrictedTooltipMsg,
  onTryNewAdoptEaseClick,
  showTryNewAdoptEaseButton,
  showTryNewAdoptEaseCampaign,
  onTryNewAdoptEaseCampaignClick,
  showNewIndicator,
  locale,
  isMobileApp = false,
}: Props) {
  const { t } = useTranslation();

  // AdoptEase campaign takes priority over the AdoptEase application button
  const adoptEaseCampaign = showTryNewAdoptEaseCampaign ? showTryNewAdoptEaseCampaign(id) : undefined;
  const tryNewAdoptEaseButton = !adoptEaseCampaign && showTryNewAdoptEaseButton ? showTryNewAdoptEaseButton(id,name) : false;

  const onMoreClick = (event:MouseEvent) => {
    event.stopPropagation();
    return false;
  }

  let clickByMenu = false;
  const onCardClick = (e:MouseEvent) => {
    !clickByMenu && !isMobileApp && onOpenClick(e);
    clickByMenu = false;
  }

  const onHandleTryNewAdoptEaseClick = (e:MouseEvent) => {
    e.stopPropagation();
    onTryNewAdoptEaseClick && onTryNewAdoptEaseClick(name);
  }

  const onHandleTryNewAdoptEaseCampaignClick = (e:MouseEvent) => {
    e.stopPropagation();
    adoptEaseCampaign && onTryNewAdoptEaseCampaignClick && onTryNewAdoptEaseCampaignClick(adoptEaseCampaign);
  }


  return (
    <>
      <Styles.Card
        data-testid={`card-${toTestId(name)}`}
        onClick={(e) => !isRestricted && isEnabled && !isBlockedByOS(requiredOS) && onCardClick(e)}
        onKeyDown={(e: any) => {
          if ((e.key === 'Enter' || e.key === ' ') && !isRestricted && isEnabled && !isBlockedByOS(requiredOS)) {
            e.preventDefault();
            onCardClick(e);
          }
        }}
      >
        <div>
          <Styles.CardHeader>
              {isIconRequired && <Styles.ProductIcon iconColor={iconColor} data-testid="app-icon">
                {iconText || ''}
              </Styles.ProductIcon> }
            <Styles.CardTitle>
              {name}
              {isRestricted && ( 
                <RestrictedTooltip message={restrictedTooltipMsg}></RestrictedTooltip>
              )}
              {shouldShowWarning(warningMessage, requiredOS) && (
                <Styles.WarningMessage>
                  <Styles.WarningIcon />{warningMessage}
                </Styles.WarningMessage>
                )}
              {isMobileApp && (
                <Styles.WarningMessage>
                  <Styles.WarningIcon data-testid="mobile-app-warning" />
                  {t('baseCard.mobileAppWarning')}
                </Styles.WarningMessage>
              )}
            </Styles.CardTitle>
          </Styles.CardHeader>
          { description && <Styles.CardDescription>{description}</Styles.CardDescription> }
        </div>
        
        <div style={{display:'flex', top:'5px', right:'5px', position:'absolute', width:'auto'}}>
          { isEnabled && !isRestricted && !isBlockedByOS(requiredOS) && adoptEaseCampaign &&
            <TryNowButtonAdoptEaseIndicator
              onTryNewAdoptEaseClick={onHandleTryNewAdoptEaseCampaignClick}
              text={getCampaignText(adoptEaseCampaign.ctaText, locale)}
              dataTestId="try-now-campaign"
              showIcon={false}
            ></TryNowButtonAdoptEaseIndicator>
          }
          { isEnabled && !isRestricted && tryNewAdoptEaseButton &&
            <TryNowButtonAdoptEaseIndicator onTryNewAdoptEaseClick={onHandleTryNewAdoptEaseClick}></TryNowButtonAdoptEaseIndicator>
          }
          {showNewIndicator && (<NewCardIndicator locale={locale} > </NewCardIndicator>)}
        </div>
        <Styles.IconWrap data-id='icon-card-more'
            style={{ top: (isIconRequired || description ? '25px' : '5px') }}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                clickByMenu=true;
                onMoreClick(e);
              }
          }}>
            <IconButton ref={menuRef} tabIndex={0} dataTestId="bc-more-btn" data-id="bc-more-btn"
              icon={<IconMoreVert />}
              onClick={onMoreClick}
              isDisabled={isRestricted}
              text=""
              onKeyDown={(e: any) => {
                  if (e.key === 'Enter') {
                    clickByMenu=true;
                    onMoreClick(e);
                  }
                }}
            />
        </Styles.IconWrap>

      </Styles.Card>

    </>
  );
}
